import {
  IS_ELECTRON,
  MIN_VERSION_FOR_UPDATE,
  SOFT_MIN_VERSION_FOR_UPDATE,
} from 'Constants/env';
import { compareVersions } from 'Utils/semver';
import { extractVersions } from 'Utils/versionExtractor';

/**
 * Returns the installed desktop app version.
 */
export const getInstalledDesktopVersion = () =>
  extractVersions(navigator.userAgent).desktop.raw;

/**
 * Returns true when the installed version is below MIN_VERSION_FOR_UPDATE.
 * This is the breaking-change gate and takes precedence over the soft gate,
 * showing the blocking update screen.
 */
export const isBlockingUpdateRequired = () => {
  if (!IS_ELECTRON) {
    return false;
  }

  return (
    compareVersions(getInstalledDesktopVersion(), MIN_VERSION_FOR_UPDATE) ===
    -1
  );
};

/**
 * Returns true when the installed version is at or above MIN_VERSION_FOR_UPDATE
 * but below SOFT_MIN_VERSION_FOR_UPDATE. This is the non-breaking gate and
 * displays a dismissible update banner.
 */
export const isSoftUpdateAvailable = () => {
  if (!IS_ELECTRON) {
    return false;
  }

  const installedVersion = getInstalledDesktopVersion();

  return (
    compareVersions(installedVersion, MIN_VERSION_FOR_UPDATE) >= 0 &&
    compareVersions(installedVersion, SOFT_MIN_VERSION_FOR_UPDATE) === -1
  );
};